/**
 * The 'iso' map mode now renders the three.js board. The old Pixi iso view
 * stays reachable as a fallback for a session where the 3D board misbehaves:
 * add ?legacy-iso to the URL, or set localStorage 'machina:legacy-iso' = '1'.
 */
export function isLegacyIso(): boolean {
  try {
    if (typeof window !== 'undefined' && window.location.search.includes('legacy-iso')) return true;
    return localStorage.getItem('machina:legacy-iso') === '1';
  } catch {
    return false;
  }
}
